const BUTTON_THEMES = {
  PRIMARY: 'primary',
  ACCENT_PRIMARY: 'accent-primary',
  TERTIARY: 'tertiary',
  ACCENT_SECONDARY: 'accent-secondary',
};

const BUTTON_SIZES = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
};

export { BUTTON_THEMES, BUTTON_SIZES };
